import CommonText from 'common/components/entities/TextNew/ui/TextUi'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import React, { forwardRef } from 'react'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import CommonCheckbox from 'src/shared/components/checkbox'
import { CheckboxEntityInterface } from 'src/shared/entities/checkbox/checkbox-entity.schema'
import { CheckboxSubEntityInterface } from 'src/shared/entities/checkbox/checkbox-sub-entity.schema'

export interface BasePublisherCheckboxProps {
  entityOrSubEntity: CheckboxEntityInterface | CheckboxSubEntityInterface
  checked: boolean
  onChange: () => void
}

export const BasePublisherCheckbox = forwardRef<
  HTMLDivElement,
  BasePublisherCheckboxProps
>(({ entityOrSubEntity, checked, onChange }, ref) => {
  const {
    text: { paragraphTextColor: globalTextColor },
    links: { linkTextColor: globalLinkColor },
  } = useThemeColor()

  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography({
    fontSize: entityOrSubEntity.fontSize,
    mobileFontSize: entityOrSubEntity.mobileFontSize,
    lineHeight: entityOrSubEntity.lineHeight,
    mobileLineHeight: entityOrSubEntity.mobileLineHeight,
    textAlign: entityOrSubEntity.textAlign || 'left',
    mobileTextAlign: entityOrSubEntity.mobileTextAlign || 'left',
    fontFamily: entityOrSubEntity.fontFamily,
    mobileFontFamily: entityOrSubEntity.mobileFontFamily,
    fontWeight: entityOrSubEntity.fontWeight,
    mobileFontWeight: entityOrSubEntity.mobileFontWeight,
    fontStyle: entityOrSubEntity.fontStyle,
    mobileFontStyle: entityOrSubEntity.mobileFontStyle,
  })

  return (
    <StyleWrapper
      mobileMargin={entityOrSubEntity.mobileMargin}
      margin={entityOrSubEntity.margin}
      appearance={entityOrSubEntity.appearance}
    >
      <CommonCheckbox
        uiProps={entityOrSubEntity}
        id={entityOrSubEntity.htmlAttrId}
        checked={checked}
        onChangeHandler={onChange}
      >
        <CommonText
          id={entityOrSubEntity.htmlAttrId}
          linkColor={globalLinkColor}
          fontSize={calculatedFontSize.desktop}
          mobileFontSize={calculatedFontSize.mobile}
          lineHeight={calculatedLineHeight.desktop}
          mobileLineHeight={calculatedLineHeight.mobile}
          color={entityOrSubEntity.color || globalTextColor}
          fontFamily={calculatedFontFamily.desktop}
          mobileFontFamily={calculatedFontFamily.mobile}
          fontStyle={calculatedFontStyle.desktop}
          mobileFontStyle={calculatedFontStyle.mobile}
          fontWeight={calculatedFontWeight.desktop}
          mobileFontWeight={calculatedFontWeight.mobile}
          padding={entityOrSubEntity.padding}
          mobilePadding={entityOrSubEntity.mobilePadding}
          textAlign={calculatedTextAlign.desktop}
          mobileTextAlign={calculatedTextAlign.mobile}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: entityOrSubEntity.content || entityOrSubEntity.html || '',
            }}
            ref={ref}
          />
        </CommonText>
      </CommonCheckbox>
    </StyleWrapper>
  )
})
